module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/29.4864ca8b.png";